import { defineStyleConfig } from '@chakra-ui/react';

export const Drawer = defineStyleConfig({
  baseStyle: {
    dialog: {
      bg: 'surface.card',
    },
    overlay: {
      bg: 'surface.overlay',
    },
  },
});
